import { render } from "./GroupAppIcon.vue?vue&type=template&id=4e9b3664&scoped=true"
import script from "./GroupAppIcon.vue?vue&type=script&lang=js"
export * from "./GroupAppIcon.vue?vue&type=script&lang=js"

import "./GroupAppIcon.vue?vue&type=style&index=0&id=4e9b3664&lang=less&scoped=true"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/jb/jb-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9b3664"]])

export default __exports__